import { store } from "../redux/store";
import { showPopup, PopupType } from "../redux/slices/popupSlice/popupSlice";
import i18n from "../i18n/config";

/**
 * Options for showing a popup
 */
export const __DEV__ = process.env.NODE_ENV === "development";

export interface ShowPopupOptions {
  /** Popup title */
  title: string;
  /** Popup message/body text */
  message: string;
  /** Application strings object (optional, for fallback text) */
  appStrings?: any;
  /** Whether to show a button (default: false) */
  showButton?: boolean;
  /** HTTP status code (determines popup type: 401/403=ERROR, 400+=WARNING, else=INFO) */
  statusCode?: number;
  /** Optional button text (default: from appStrings or "אישור") */
  buttonText?: string;
}

/**
 * Rounds `amount` DOWN to the nearest multiple of `basis` for UI display only.
 * Event logs (e.g. `remaining_usage_amount_il`) must keep the exact amount.
 * If basis is missing/invalid (<= 1), the amount is returned unchanged.
 * Example: roundDownRemainingUsage(26157, 100) -> 26100
 */
export const roundDownRemainingUsage = (
  amount: number | null | undefined,
  basis: number | null | undefined
): number => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return 0;
  const b = Number(basis);
  if (!Number.isFinite(b) || b <= 1) return value;
  return Math.floor(value / b) * b;
};


